/**
 * @description Authentication Store Module
 * @author Fahid Mohammad
 */

import http from '../../util/axios'
const VueCookie = require('vue-cookie') // using require to avoid SSR rejection
export default {
    namespaced: true,
    state: {
        isLoggedIn:false,
        isLoading:false,
        token:"",
        userId:""
    },
    mutations:{
        addIsLoggedIn: (state, status) => {
            state.isLoggedIn = status
        },
        removeIsLoggedIn: (state) => {
            state.isLoggedIn = false
        },
        addLogin: (state, {status, token}) => {
            state.isLoggedIn = status
            state.token = token
        },
        setLoading: (state, status) => {
            state.isLoading = status
        }
    },
    actions:{
        SET_ISLOGGEDIN({ commit }, status) {
            commit('addIsLoggedIn', { status })
        },
        LOGIN_REQUEST({ commit }, form) {
            commit('setLoading', true)
            return http.post("/hms/login", form).then(response => {
                commit('setLoading', false)
                let status = false, token = null;
                if(response.status===1000){
                    status = true; token = response.token;
                    //  Commit to store
                    commit('addLogin', { status, token })
                    //  Set cookie
                    VueCookie.set('token',token);
                    localStorage.setItem('userData',JSON.stringify(response.userdata));
                    localStorage.setItem('fnids',JSON.stringify(response.f));
                    localStorage.setItem('eventids',JSON.stringify(response.e));
                    localStorage.setItem('servicetypes',JSON.stringify(response.services));
                    return {status:response.status, userData:response.userdata}
                }else{
                    return {status:response.status, userData: response}
                    
                }
            })
        },
        CHANGEPASSWORD_REQUEST({ commit }, form) {
                return http.post("/hms/changePassword", form).then(response => {
                    let _self = this;
                    if(response.status===1000){
                        return {status: true, message: response.message}
                    }
                    else if(response.status===1001){
                        return {status: false, message:response.message};
                    }
                    else{
                        return {status: false, message:response.message};
                    }
                })
        },
        UPDATE_LOGIN({ commit }, {status, token}) {
            commit('addLogin', { status, token })
        },
        LOGOUT({commit}){
            return new Promise((resolve, reject) => {
                VueCookie.delete('token');
                let status = false, token = null;
                localStorage.clear();
                commit('addLogin', { status, token })
                setTimeout(function(){ // to avoid glitch in SSR router push
                    resolve(true)
                },200)
            })
        },
        CHILD_AUTH({ commit }, form) {
            commit('setLoading', true)
            return http.post('/hms/generateTokenForCH', form).then(response => {
                console.log('RES', response)
                commit('setLoading', false)
                let status = false, token = null;
                if(response.status===1000){
                    VueCookie.delete('token');
                    status = true; token = response.token;
                    //  Commit to store
                    commit('addLogin', { status, token })
                    //  Set cookie
                    VueCookie.set('token',token);
                    localStorage.setItem('userData',JSON.stringify(response.userdata));
                    localStorage.setItem('fnids',JSON.stringify(response.f));
                    localStorage.setItem('eventids',JSON.stringify(response.e));
                    localStorage.setItem('servicetypes',JSON.stringify(response.services));
                    return response
                }else{
                    commit('setLoading', false)
                    return response
                    
                }
            })
        },
    },
    getters:{
        getLoginStatus: state => {
            return state.isLoggedIn
        },
        getToken : state =>{
            return state.token
        },
    }
}
    



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js